import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { emotionTransform, MantineEmotionProvider } from '@mantine/emotion';
import { Notifications } from '@mantine/notifications';
import { AuthProvider } from './contexts/AuthContext';
import { Router } from './routing/Router';
import { theme } from './theme';

import './app.css';
import 'dayjs/locale/pt-br';

dayjs.extend(customParseFormat);
dayjs.locale('pt-br');

const queryClient = new QueryClient();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <MantineProvider theme={theme} defaultColorScheme="light" stylesTransform={emotionTransform}>
      <MantineEmotionProvider>
        <Notifications position="top-center" autoClose={5000} />
        <AuthProvider>
          <Router />
        </AuthProvider>
      </MantineEmotionProvider>
    </MantineProvider>
  </QueryClientProvider>
);
